module.exports = __webpack_public_path__ + "static/media/card5_7.c40a49cc.png";